import { render, staticRenderFns } from "./Waiting.vue?vue&type=template&id=3fbcadc6&scoped=true&"
import script from "./Waiting.vue?vue&type=script&lang=js&"
export * from "./Waiting.vue?vue&type=script&lang=js&"
import style0 from "./Waiting.vue?vue&type=style&index=0&id=3fbcadc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbcadc6",
  null
  
)

export default component.exports